import * as React from 'react';
import {Button, Icon, Slider} from 'antd';

import {Question} from '../../api/HollandClient';
import {zeroPad} from "../../utils/StringUtils";

export interface Props{
  question: Question,
  indice: number,
  nextQuestion: () => void,
  prevQuestion: () => void,
  finish: () => void,
  onSelectAnswer: (answer: any) => void,
  lastQuestion: boolean,
  index: number,
  selectedValue: number,
}

export interface State{
  value: number,
}

import styles from './HollandQuestion.module.scss';
class HollandQuestion extends React.Component<Props, State>{

  public state = {
    value: this.props.selectedValue
  };

  public render(){

    const marks = {
      0: '0',
      1: '1',
      2: '2',
      3: '3',
      4: '4',
      5: '5',
    };

    const { question, indice } = this.props;
    const { value } = this.state;

    return (
      <>
        <div className={value > -1 ? styles.selected : styles.hollandQuestion}>
          <div className={styles.hollandQuestion__header}>
            <p><strong>{question.texto}</strong></p>
            <div className={styles.hollandQuestion__index}>
              {zeroPad(indice, 2)}
            </div>
          </div>
          <Slider marks={marks}
                  defaultValue={this.props.selectedValue}
                  step={1}
                  min={0}
                  max={5}
                  onChange={(value: any) => this.onChange(value)}/>

        </div>
        <div className={styles.hollandQuestion__steps}>
          <Button.Group>
            <Button type="primary"
                    disabled={this.props.index === 0}
                    onClick={this.props.prevQuestion}>
              <Icon type="left" />Anterior
            </Button>
            {!this.props.lastQuestion &&
            <Button type="primary" onClick={this.props.nextQuestion}>
              Próxima<Icon type="right"/>
            </Button>
            }
            {this.props.lastQuestion &&
            <Button type="primary" onClick={this.props.finish}>
              Terminar <Icon type="check" />
            </Button>
            }

          </Button.Group>

        </div>
      </>

    )
  }

  private onChange = (value: number) => {
    this.setState({
      value,
    });

    this.props.onSelectAnswer({index: this.props.index, valor: value});
  }
}

export default HollandQuestion;
